import { Button } from "@/components/ui/button";
import {
  Calendar, FileText, Target, Upload, BarChart3, CreditCard,
  UserPlus, Send, Briefcase
} from "lucide-react";

export function QuickActionsBar({ onNavigate }) {
  const actions = [
    { label: "Schedule Meeting", icon: Calendar, action: () => onNavigate("scheduleMeeting"), color: "text-blue-600 hover:bg-blue-50" },
    { label: "New Invoice", icon: CreditCard, action: () => onNavigate("billing"), color: "text-emerald-600 hover:bg-emerald-50" },
    { label: "Add Client", icon: UserPlus, action: () => onNavigate("addClient"), color: "text-purple-600 hover:bg-purple-50" },
    { label: "Scaling Tools", icon: Target, action: () => onNavigate("scaling"), color: "text-amber-600 hover:bg-amber-50" },
    { label: "Import Leads", icon: Upload, action: () => onNavigate("leads"), color: "text-cyan-600 hover:bg-cyan-50" },
    { label: "Sales Agents", icon: Send, action: () => onNavigate("salesAgents"), color: "text-green-600 hover:bg-green-50" },
    { label: "Blog", icon: FileText, action: () => onNavigate("blog"), color: "text-rose-600 hover:bg-rose-50" },
    { label: "Reports", icon: BarChart3, action: () => onNavigate("clientProgress"), color: "text-indigo-600 hover:bg-indigo-50" },
  ];

  return (
    <div className="flex items-center gap-1.5 overflow-x-auto pb-1 mb-4" data-testid="quick-actions-bar">
      {actions.map(a => (
        <Button key={a.label} variant="ghost" size="sm" onClick={a.action}
          className={`flex-shrink-0 h-8 text-xs font-medium ${a.color} border border-transparent hover:border-neutral-200`}>
          <a.icon className="w-3.5 h-3.5 mr-1" />{a.label}
        </Button>
      ))}
    </div>
  );
}

export default QuickActionsBar;
